import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ValidatorHelper  {
    _originalTypeClassName = "zERP.BO.ValidatorHelper";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ValidatorHelper.translate = translateService;
}
this.ValidatorHelperKey = null;
this._key = this.ValidatorHelperKey = 0; 
}

static translate: TranslateService;
_key: any;
private _ValidatorHelperKey:any;
get ValidatorHelperKey(): any {
    return this._ValidatorHelperKey;
  }
set ValidatorHelperKey(value: any) {
    this._ValidatorHelperKey = value;
    this._key = value;
  }

static ValidateAFM(AFM: any): any{if (AFM == null) {return null;}
if (CLMS.Framework.Number.NotEqual(() => AFM.length, () => 9)) {return this.translate.instant('UtilitiesBO_AFM_Length');}
try {let number = CLMS.Framework.Long.Parse(AFM);}
catch (e) {return this.translate.instant('UtilitiesBO_AFM_Invalid');}
if (AFM == "999999999") {return null;}
let A1 = CLMS.Framework.Integer.Parse(AFM?.substr(0, 1));
let A2 = CLMS.Framework.Integer.Parse(AFM?.substr(1, 1));
let A3 = CLMS.Framework.Integer.Parse(AFM?.substr(2, 1));
let A4 = CLMS.Framework.Integer.Parse(AFM?.substr(3, 1));
let A5 = CLMS.Framework.Integer.Parse(AFM?.substr(4, 1));
let A6 = CLMS.Framework.Integer.Parse(AFM?.substr(5, 1));
let A7 = CLMS.Framework.Integer.Parse(AFM?.substr(6, 1));
let A8 = CLMS.Framework.Integer.Parse(AFM?.substr(7, 1));
let A9 = CLMS.Framework.Integer.Parse(AFM?.substr(8, 1));
let sum = Joove.Common.safeNumber(256) * Joove.Common.safeNumber(A1) + Joove.Common.safeNumber(128) * Joove.Common.safeNumber(A2) + Joove.Common.safeNumber(64) * Joove.Common.safeNumber(A3) + Joove.Common.safeNumber(32) * Joove.Common.safeNumber(A4) + Joove.Common.safeNumber(16) * Joove.Common.safeNumber(A5) + Joove.Common.safeNumber(8) * Joove.Common.safeNumber(A6) + Joove.Common.safeNumber(4) * Joove.Common.safeNumber(A7) + Joove.Common.safeNumber(2) * Joove.Common.safeNumber(A8);
let mod = Joove.Common.safeNumber((Joove.Common.safeNumber(sum) % Joove.Common.safeNumber(11))) % Joove.Common.safeNumber(10);
if (CLMS.Framework.Number.NotEqual(() => mod, () => A9)) {console.warn("invalid AFM: " + AFM);console.warn("sum: " + Joove.Common.safeNumber(sum));console.warn("mod: " + Joove.Common.safeNumber(mod));return this.translate.instant('UtilitiesBO_AFM_Invalid');}
return null;
}
static ValidateAMKA(AMKA: any,dateOfBirth: any,required: any): any{if (!(required) && CLMS.Framework.String.IsNullOrEmpty((AMKA ?? '').trim())) {return null;}
if (CLMS.Framework.Number.NotEqual(() => AMKA.length, () => 11)) {return this.translate.instant('UtilitiesBO_AMKA_Length');}
try {let day = CLMS.Framework.Integer.Parse(AMKA?.substr(0, 2));let month = CLMS.Framework.Integer.Parse(AMKA?.substr(2, 2));let year = CLMS.Framework.Integer.Parse(AMKA?.substr(4, 2));console.warn("Day: " + Joove.Common.safeNumber(day) + " month: " + Joove.Common.safeNumber(month) + " year: " + Joove.Common.safeNumber(year));console.warn("Day: " + Joove.Common.safeNumber(moment(dateOfBirth).date()) + " month: " + Joove.Common.safeNumber((moment(dateOfBirth).month() + 1)) + " year: " + Joove.Common.safeNumber(CLMS.Framework.Integer.Parse(moment(dateOfBirth).year()?.toString()?.substr(2))));if (CLMS.Framework.Number.NotEqual(() => day, () => moment(dateOfBirth).date()) || CLMS.Framework.Number.NotEqual(() => month, () => (moment(dateOfBirth).month() + 1)) || CLMS.Framework.Number.NotEqual(() => year, () => CLMS.Framework.Integer.Parse(moment(dateOfBirth).year().toString().substr(2)))) {return this.translate.instant('UtilitiesBO_AMKA_Date');}}
catch (e) {return this.translate.instant('UtilitiesBO_AMKA_Masked');}
return null;
}
static ValidatePersonalNumber(personalnumber: any,afm: any,required: any): any{if (personalnumber == null && !(required)) {return null;}
if (CLMS.Framework.Number.NotEqual(() => personalnumber.length, () => 12)) {return this.translate.instant('UtilitiesBO_PERSONALNUMBER_Length');}
if (CLMS.Framework.String.IsNullOrEmpty((afm ?? '').trim())) {return this.translate.instant('UtilitiesBO_PERSONALNUMBER_AFMNULL');}else {if (Joove.Common.stringContains(personalnumber, afm)) {return null;}else {return this.translate.instant('UtilitiesBO_PERSONALNUMBER_WRONG');}}
return null;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ValidatorHelperKey == null || $this.ValidatorHelperKey == 0;
            }


}